var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-4",attrs:{"small":"","right":"","data-test":`${_vm.dataTest}Add`},on:{"click":_vm.createNew}},[_vm._v("\n  Добавить\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }